<div>
  <br>
  <br>

  <app-pec-lists [pecId]="pecId" [withFilter]="withFilter" [withSearchBar]="withSearchBar" [viewMode]="viewMode"
    [addButton]="addButton"></app-pec-lists>

</div>